export enum Role {
    ADMIN = 'admin',
    ANALYST = 'analyst',
    EXTERNAL_ANALYST = 'external analyst'
}
